import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fiscam',
  templateUrl: './fiscam.component.html',
  styleUrls: ['./fiscam.component.scss']
})
export class FiscamComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
